import styled from "styled-components";

import { Tr } from "commons";

const MAX_WIDTH_FROM_THEME_RATIO = 1.2;

export const TrxTr = styled(Tr)`
    ${props =>
        props.isClientPortal &&
        `
    @media only screen and (max-width: ${
        parseFloat(props.theme.maxWidth) * MAX_WIDTH_FROM_THEME_RATIO
    }px) {
        td, th {
            :nth-of-type(1) {
                width: 10%;
            }

            :nth-of-type(2) {
                width: 11%;
            }

            :nth-of-type(3) {
                width: 11%;
            }

            :nth-of-type(4) {
                width: 19%;
            }
        }
    }
    @media only screen and (max-width: ${props.theme.maxWidth}) {
        display: block;
        margin: 10px;
        background-color: white;
        border: 4px solid white;
        outline: 1px solid lightgrey;
        padding: 5px;

        td {
            display: block;
            border: none;
            position: relative;
            text-align: left !important;
            min-height: 30px;
            color: black;
            font-size: 1.2em;
            font-weight: 300;
            padding-right: 2px;

            :empty {
                display: none !important;
            }

            :before {
                position: absolute;
                top: 8px;
                left: 8px;
                width: 45%;
                padding-right: 10px;
                white-space: nowrap;
                color: black;
                text-align: left !important;
            }

            :nth-of-type(2) {
                border-bottom: 1px solid #70655D;
            }

            :nth-of-type(2), :nth-of-type(5), :nth-of-type(6), :nth-of-type(7), :nth-of-type(8), :nth-of-type(9) {
                text-align: right !important;
            }

            :nth-of-type(2) {
                width: 100%;
                font-size: 1em;
                color: #70655D;

                :before {
                    content: "Cash balance";
                    left: 8px !important;
                    color: #70655D;
                }
            }

            :nth-of-type(4) {
                width: 60%;
            }

            :nth-of-type(n+9) {
                width: 100%;
                top: -35px;
            }

            :nth-of-type(8):before {
                content: "Fees";
                width: 40%;
            }

            :nth-of-type(5) {
                width: 40%;
                float: right;
                top: -37px;
            }

            :nth-of-type(3), :nth-of-type(6), :nth-of-type(7) {
                display: none !important;
            }
        }
    }`}
`;
